import { createContext, useState, useEffect, useContext } from 'react'
import { authContext } from 'contexts/AuthContext'
import { myAccount } from 'services/api/authentication'
import { profile } from 'services/api/profile'

export const ProfileContext = createContext()

const ProfileContextProvider = (props) => {
  const { auth } = useContext(authContext)
  const [profileData, setProfileData] = useState(null)
  const [dobData, setDobData] = useState(null)

  const getProfile = async () => {
    try {
      const results = await myAccount()
      setProfileData(results?.data || results)
    } catch (e) {
      console.error(e)
    }
  }

  const getDob = async () => {
    try {
      const results = await profile()
      setDobData(results?.data || results)
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    if (auth.isAuth) {
      getProfile()
      getDob()
    } else {
      setProfileData(null)
      setDobData(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isAuth])

  return (
    <ProfileContext.Provider
      value={{
        profileData,
        dobData,
        getProfile,
        getDob,
      }}
    >
      {props.children}
    </ProfileContext.Provider>
  )
}

export default ProfileContextProvider
